/**
 * Calendar item types
 */
export enum CalendarItemType {
	Event = "event",
	Task = "task",
	Order = "order",
	Holiday = "holiday"
}
